module.exports = __webpack_public_path__ + "static/media/green-harvest.2e30a994.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/green-harvest.jpg
 ** module id = 291
 ** module chunks = 0
 **/